import { render, staticRenderFns } from "./ClientsTable.vue?vue&type=template&id=c65ac95a"
import script from "./ClientsTable.vue?vue&type=script&lang=js"
export * from "./ClientsTable.vue?vue&type=script&lang=js"
import style0 from "./ClientsTable.vue?vue&type=style&index=0&id=c65ac95a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataFooter } from 'vuetify/lib/components/VDataIterator';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VDataFooter,VDataTable,VSelect,VTextField,VToolbar})
